import { render, staticRenderFns } from "./DesktopLightBoxB.vue?vue&type=template&id=1d44f790&"
import script from "./DesktopLightBoxB.vue?vue&type=script&lang=js&"
export * from "./DesktopLightBoxB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports